export const bulkImportStatus = {
  RESERVED: '処理待ち',
  COMPLETED: '処理完了',
  PROCESSING: '処理中',
  FAILED: '処理失敗',
} as const;

export type BulkImportStatusKey = keyof typeof bulkImportStatus;

export const bulkImportStatusKeys = Object.keys(bulkImportStatus) as BulkImportStatusKey[];

/** v-select用items */
export const bulkImportStatusItems = bulkImportStatusKeys
  .map((key) => ({
    title: bulkImportStatus[key],
    value: key,
  }));
